import { DateUtil, LocalDateUtil } from 'gw-portals-util-js';
import moment from 'moment';
import _ from 'lodash';

const MS_PER_DAY = 1000 * 60 * 60 * 24;

export default _.extend(DateUtil, {
    dateDiffInDays: function dateDiffInDays(date, dateDTO) {
        // Discard the time and time-zone information.
        if (!this.dateIsValid(dateDTO)) {
            return undefined;
        }
        const utc1 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        const utc2 = Date.UTC(dateDTO.year, dateDTO.month, dateDTO.day);
        return Math.floor((utc2 - utc1) / MS_PER_DAY);
    },

    dateDTODiffInYears: function dateDTODiffInYears(dateDTO, secondDateDTO) {
        const firstDate = moment(`${dateDTO.year.toString()}-${dateDTO.month.toString()}-${dateDTO.day.toString()}`, 'YYYY-MM-DD');
        const secondDate = moment(`${secondDateDTO.year.toString()}-${secondDateDTO.month.toString()}-${secondDateDTO.day.toString()}`, 'YYYY-MM-DD');
        const difference = moment.duration(firstDate.diff(secondDate));
        const years = difference.asYears();
        return Math.floor(years);
    },

    dateDTODiffInDays: function dateDTODiffInDays(dateDTO, secondDateDTO) {
        if (!this.dateIsValid(dateDTO) || !this.dateIsValid(secondDateDTO)) {
            return undefined;
        }
        const firstDate = this.toMomentDate(dateDTO);
        const secondDate = this.toMomentDate(secondDateDTO);
        const days = firstDate.diff(secondDate, 'days');
        return Math.floor(days);
    },
    /**
     * @param {Object} dateDTO
     * @returns {*} LocalDateDTO as short format String (eg. 01/01/2017)
     */
    toStringShort: function toStringShort(dateDTO) {
        return this.dateIsValid(dateDTO) ? moment(LocalDateUtil.toMidnightDate(dateDTO)).format('DD/MM/yyyy') : '';
    },
    toLongDate: function toLongDate(dateDTO) {
        return this.dateIsValid(dateDTO) ? moment(LocalDateUtil.toMidnightDate(dateDTO)).format('DD MMMM yyyy') : '';
    },
    addDaysToDateDTO: function (numberOfDays, dateDTO) {
        return this.dateIsValid(dateDTO) ? this.toLocalDateDto(moment(LocalDateUtil.toMidnightDate(dateDTO)).add(numberOfDays, 'days').toDate()) : '';
    },
    addDaysToLongDate: function (numberOfDays, dateDTO) {
        return this.dateIsValid(dateDTO) ? moment(LocalDateUtil.toMidnightDate(dateDTO)).add(numberOfDays, 'days').format('DD MMMM yyyy') : '';
    },
    toMonthYear: function toMonthYear(dateDTO) {
        return this.dateIsValid(dateDTO) ? moment(LocalDateUtil.toMidnightDate(dateDTO)).format('MMM yyyy') : '';
    },

    toDateString: function toDateString(dateDTO) {
        return this.dateIsValid(dateDTO) ? moment(LocalDateUtil.toMidnightDate(dateDTO)).format('yyyy-MM-DD') : '';
    },

    dateIsValid: function dateIsValid(dateDTO) {
        return dateDTO !== undefined && dateDTO.day !== undefined && dateDTO.month !== undefined && dateDTO.year !== undefined
            && dateDTO.year.toString().length === 4 && moment([dateDTO.year, dateDTO.month, dateDTO.day]).isValid();
    },

    isDateDtoEmpty: (dateDTO) => {
        return dateDTO === undefined || (dateDTO.day === undefined && dateDTO.month === undefined && dateDTO.year === undefined);
    },

    compareDateTime: (date1, date2) => {
        const date1Time = new Date(date1);
        const date2Time = new Date(date2);

        if (date1Time > date2Time) {
            return true;
        }
        return false;
    },

    toLocalDateDto: (date) => {
        const momentDate = moment(date);
        const localDateDto = {
            day: undefined,
            month: undefined,
            monthViewValue: undefined,
            year: undefined
        };
        if (momentDate && momentDate.isValid()) {
            localDateDto.day = momentDate.format('D');
            localDateDto.month = momentDate.month();
            localDateDto.monthViewValue = momentDate.format('M');
            localDateDto.year = momentDate.format('YYYY');
        }
        return localDateDto;
    },

    toDate: (localDateDto) => {
        const date = moment(LocalDateUtil.toMidnightDate(localDateDto));
        if (date && date.isValid()) {
            return date.toDate();
        }
        return undefined;
    },

    toMomentDate: (localDateDto) => {
        const date = moment(LocalDateUtil.toMidnightDate(localDateDto));
        if (date && date.isValid()) {
            return date;
        }
        return undefined;
    },

    getDateWithFullMonthName: (date) => {
        if (!date) {
            return '';
        }
        const monthName = moment().month(date.month).format('MMMM');
        return `${date.day} ${monthName} ${date.year}`;
    },

    formatDate: (value) => {
        return moment(new Date(value.year, value.month, value.day, value.hour, value.minute, value.second, value.millisecond))
            .format('YYYY-MM-DD HH:mm:ss');
    },

    /*
     * @param {Date} dob Date of Birth
     * @returns Age based on Date of Birth
     */
    calcAge: (dob) => {
        const today = new Date();
        const hadBirthdayThisYear = (today.getMonth() > dob.getMonth() || (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate()));
        const age = today.getFullYear() - dob.getFullYear() - (hadBirthdayThisYear ? 0 : 1);
        return age;
    },

    formatValue: (value) => {
        if (!_.isNil(value)
            && ((typeof value === 'string' && value.length === 1) || (typeof value !== 'string' && value < 10))) {
            return `0${value}`;
        }
        return value;
    },

    isTodaySameOrBeforeSpecificDate: (date) => {
        return moment().isSameOrBefore(date, 'day');
    }
});
